<template>
  <div id="delivery-navbar">
    <font-awesome-icon
      @click="goToMenu"
      id="delivery-back-icon"
      icon="chevron-left"
      :style="{ color: '#198b4a ' }"
    />
    <p id="delivery-order-title">{{ labels.delivery.order[language] }}</p>
    <a v-if="!isApplication" id="link-to-landing" href="#">
      <img id="delivery-navbar-logo" src="../assets/Full_logo.svg" alt />
    </a>
  </div>
</template>

<script>
export default {
  props: ["isApplication", "isPda"],
  computed: {
    tableId() {
      return this.$store.getters.getTableId;
    },

    language() {
      return this.$store.getters.getLanguage;
    },
  },
  methods: {
    goToMenu: function () {

      let queryObject = null;
      if (this.$route.query && this.$route.query.isPda != undefined && this.$route.query.pdaId != undefined && this.$route.query.tableId != undefined) {
        queryObject = { isPda: this.$route.query.isPda, pdaId: this.$route.query.pdaId, tableId: this.$route.query.tableId };
        if (this.$route.query.tableOpeningId != undefined) {
          queryObject.tableOpeningId = this.$route.query.tableOpeningId;
        }

        if (this.$route.query.pdaUserId != undefined) {
          queryObject.pdaUserId = this.$route.query.pdaUserId;
        }

        if (this.$route.query.fromOpenTable != undefined && (this.$route.query.fromOpenTable == true || this.$route.query.fromOpenTable == 'true')) {
          queryObject.fromOpenTable = this.$route.query.fromOpenTable;
        }

        if (this.$route.query.reFetchMenuFromServer != undefined && (this.$route.query.reFetchMenuFromServer == true || this.$route.query.reFetchMenuFromServer == 'true')) {
          queryObject.reFetchMenuFromServer = this.$route.query.reFetchMenuFromServer;
        }

        if (this.$route.query.hideBackToServicesButton != undefined && (this.$route.query.hideBackToServicesButton == true || this.$route.query.hideBackToServicesButton == 'true')) {
          queryObject.hideBackToServicesButton = this.$route.query.hideBackToServicesButton;
        }

      } else if (this.$route.query && this.$route.query.backTo != undefined) {
        queryObject = { backTo: this.$route.query.backTo }
      }

      if (this.$route.query && this.$route.query.originTableId != undefined) {
        if (queryObject == null) {
          queryObject = { originTableId: this.$route.query.originTableId };
        } else {
          queryObject.originTableId = this.$route.query.originTableId;
        }
      }

      if (this.$route.query && this.$route.query.clientId != undefined) {
        if (queryObject == null) {
          queryObject = { clientId: this.$route.query.clientId };
        } else {
          queryObject.clientId = this.$route.query.clientId;
        }
      }

      let routeToPush = this.isPda ? "pda-menu" : "menu";
      this.$router.push({ name: routeToPush, params: { tableId: this.tableId }, query: queryObject });
    },
  },
};
</script>

<style scoped>
#delivery-navbar {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 53px;
  width: 100%;
  padding: 0 2.5% 0 5%;
  background: white;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  z-index: 206;
}

#delivery-back-icon {
  font-size: calc(0.65rem + 2vw);
  z-index: 2;
}

#delivery-order-title {
  position: absolute;
  width: 100%;
  text-align: center;
  left: 0;
  margin: 0;
  padding: 0;
  font-weight: 600;
}

#link-to-landing {
  height: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
}

#delivery-navbar-logo {
  background: white;
  height: 55%;
  max-height: 31px;
  cursor: pointer;
}
</style>